/**
 * Loaded FES2014 stations (the small constituent JSON the extractor writes).
 * Empty until scripts/extract_fes.py has produced public/tides/fes/stations.json
 * from Edd's FES files; the tide card falls back gracefully meanwhile.
 */
import { create } from 'zustand';
import { loadFesStations } from '@/tides/fesStations';
import type { FesStation } from '@/tides/fes';

interface FesStationsState {
  stations: FesStation[];
  loaded: boolean;
  load: () => Promise<void>;
}

export const useFesStationsStore = create<FesStationsState>((set, get) => ({
  stations: [],
  loaded: false,
  load: async () => {
    if (get().loaded) return;
    const stations = await loadFesStations();
    set({ stations, loaded: true });
  },
}));
